export default {"src":"/_next/static/media/balcony.466d1935.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};